import { render } from "./AiOverview.vue?vue&type=template&id=6c727550&scoped=true"
import script from "./AiOverview.vue?vue&type=script&lang=js"
export * from "./AiOverview.vue?vue&type=script&lang=js"

import "./AiOverview.vue?vue&type=style&index=0&id=6c727550&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src198257980/src/impact-vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c727550"]])

export default __exports__